import { join } from 'node:path';

export const SENTRY_DSN =
  'https://22f50012d85a41e78a75ae13d92bd04f@o37417.ingest.sentry.io/4505232975593472';

export const ERROR_LOG_FILENAME = 'wix-error.log';

export function getErrorLogFilePath(cwd: string) {
  return join(cwd, ERROR_LOG_FILENAME);
}
